import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import "../../css/contact/app-contact.scss";

const ContactPage = () => (
  <div>
    <header className="header">
      <h1>CONTACT US</h1>
    </header>
    <div className="pt-5 pb-5 mt-1 mb-1 contact-row ">
      <Container>
        <Row className="justify-content-center align-items-center ">
          <Col lg={10} className="contact-box">
            <Row className="align-items-stretch">
              <Col xs={6} className="contact-box-left d-flex align-items-center">
                <p className="contact-p">
                  <span className="number">197</span> North Ridge Road<br />
                  Mazar House<br />
                  Morningside<br />
                  Durban(South Africa) <span className="number">40001</span> <br/>
                  <a href="mailto:info@natedsystems.co.za">info@natedsystems.co.za</a> <br/>
                  <a href="tel:+27310013206" className="number">+27 31 001 3206</a> <br/>
                </p>
              </Col>
              <Col xs={6} className="contact-box-right p-4">
                <h5 className="text-center h-header pb-2 mb-2">TALK TO US</h5>
              <Form>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  {/* <Form.Label>Email address</Form.Label> */}
                  <Form.Control type="email" placeholder="Email" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  {/* <Form.Label>Full Name</Form.Label> */}
                  <Form.Control type="email" placeholder="Full Name" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  {/* <Form.Label>Phone</Form.Label> */}
                  <Form.Control type="email" placeholder="Phone" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  {/* <Form.Label>Phone</Form.Label> */}
                  <Form.Text as="textarea" rows={4} placeholder="Message" />
                </Form.Group>
                <Row className="align-content-center">
                    <Button variant="primary" type="submit" className="w-50 text-center">
                      SEND
                    </Button>
                </Row>
              </Form>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
    <div className="pt-0 pb-0">
      <Maps/>
    </div>
    <div className="pt-5 pb-5 con-message">
      <h2 className="text-light text-center">IN A WORLD OF TECHNOLOGY, WE MAKE A DIFFERENCE.</h2>
    </div>
  </div>
);



const containerStyle = {
  width: '100%',
  height: '400px'
};

const center = {
  lat: -29.8207305,
  lng: 31.008631
};
const marker = {
  lat: -29.8207305,
  lng: 31.008631
};

const Maps = () =>  (
    <LoadScript googleMapsApiKey="AIzaSyBWOMyEmxZVyeidLLRrsdIH-Mb_zAaF7cM">
      <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={15} >
        <Marker position={marker}></Marker>
      </GoogleMap>
    </LoadScript>
  );
export default ContactPage;